
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';


import { Link } from "react-router-dom";
import finn from "../../assets/finn.png";
import magyar from "../../assets/magyar.png";
import arrow from "../../assets/arrow.png"


function FinnMagyar({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Finn magyar fordító</title>
                <meta name='description' content="Ingyenes finn magyar fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Finn magyar fordító" />
                <link rel="canonical" href="https://online-fordito.hu/finn-magyar-fordito" />
            </Helmet>
            <h1>Finn magyar fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>

                <div className="sectionhead">
                    <h2>A finn nyelvről</h2>
                    <img src={finn} alt="A finn zászló"></img>

                </div>

                <p>A finnugor nyelvcsaládba tartozó finn nyelv Finnország hivatalos nyelve, amelyet a lakosság többsége beszél. Svédországban, Norvégiában és Oroszországban is kisebbségi nyelvként ismerik el. A finn nyelv más nyelvek között különlegességéről és egyediségéről ismert, ami nagyrészt összetett nyelvtani és gazdag hangtani jellemzőinek köszönhető.</p>

                <p>A finn nyelv agglutináló nyelvnek minősül, ami azt jelenti, hogy a szavakat úgy alkotják, hogy az alapszóhoz különböző utótagokat és végződéseket adnak hozzá. Ez a tulajdonság lehetővé teszi a kiterjedt szószármazást és a szóflektálást, így egyetlen gyökből számos szóalak jöhet létre. A nyelv 15 esetet használ, amelyek a nyelvtani kapcsolatok jelölésére és a mondaton belüli jelentés közvetítésére szolgálnak.</p>

                <p>Egyik figyelemre méltó aspektusa a magánhangzó-harmónia, ahol a szó magánhangzóit a szomszédos magánhangzók befolyásolják. Ez a tulajdonság zeneiséget és ritmust kölcsönöz a nyelvnek. A finn nyelvnek nyolc magánhangzója és 18 mássalhangzója van, és minden betű külön hangot jelöl.</p>

                <p>Annak ellenére, hogy a finn az uráli nyelvcsalád tagja, jelentős számú kölcsönszót vett át más nyelvekből, többek között a svédből, a németből és az oroszból. Ez a történelmi hatásoknak és Finnország földrajzi elhelyezkedésének köszönhető.</p>

                <p>A finn nyelv írásrendszere viszonylag egyszerű, a latin ábécét használja néhány kiegészítő karakterrel. A finn szavak kiejtése általában kiszámítható, és a nyelv alapjainak elsajátítása után következetes szabályokat követ.</p>

                <p>Összességében a finn egy lenyűgöző nyelv, amely tükrözi Finnország kulturális és történelmi örökségét. Sajátos nyelvtana, magánhangzó-harmóniája és gazdag hangtana hozzájárul egyedi jellegéhez, így a nyelvrajongók és a nyelvtanulók számára egyaránt magával ragadó nyelvvé válik.</p>

                <div className="sectionbottom">
                    <Link to="/magyar-finn-fordito">Magyar finn fordító</Link>

                    <img src={finn} alt="finn zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>

                </div>
            </section>
        </>

    )
}

export default FinnMagyar;